module.exports = __webpack_public_path__ + "static/media/katy.4eb1dcf7.jpeg";